import { render, staticRenderFns } from "./InvoicePartnerList.vue?vue&type=template&id=57024c94&scoped=true&"
import script from "./InvoicePartnerList.vue?vue&type=script&lang=js&"
export * from "./InvoicePartnerList.vue?vue&type=script&lang=js&"
import style0 from "./InvoicePartnerList.vue?vue&type=style&index=0&id=57024c94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57024c94",
  null
  
)

export default component.exports